// extracted by mini-css-extract-plugin
export default {"website":"Url_website__m9md8"};